<template>
  <div
    class="bbp-string-cell-edit"
    :style="styleItem"
  >
    <template v-if="isEdit">
      <input
        v-model="defaultValue"
        class="bbp-string-cell-edit__input"
        :class="{'bbp-string-cell-edit__input_error': column.isError}"
        :type="typeInput"
        required
        @click.prevent.stop
      >
      <div
        class="bbp-string-cell-edit__icon bbp-string-cell-edit__icon_unsave"
        @click="onUnSave"
        v-html="UN_SAVE_ICON()"
      >
      </div>
      <div
        class="bbp-string-cell-edit__icon bbp-string-cell-edit__icon_save"
        @click="onSave"
        v-html="SAVE_ICON()"
      >
      </div>
    </template>
    <template v-else>
      <div
        v-if="defaultValue"
        :id="`StringCellEditTextId_${rowId}`"
        class="bbp-string-cell-edit__content"
      >
        {{ defaultValue }}
      </div>
      <div
        v-if="hover === rowId && !isNoClick"
        :id="`StringCellEditIconId_${rowId}`"
        class="bbp-string-cell-edit__icon"
        @click="onEdit"
        v-html="EDIT_ICON()"
      >
      </div>
    </template>
  </div>
</template>

<script>
import { get, set } from 'lodash'
import {
  EDIT_ICON,
  UN_SAVE_ICON,
  SAVE_ICON
} from '@/constants/icons'

export default {
  name: 'BBPStringCellEdit',
  props: ['hover', 'column', 'row'],
  data: () => ({
    isEdit: false,
    defaultValue: '',
    EDIT_ICON,
    UN_SAVE_ICON,
    SAVE_ICON
  }),
  computed: {
    styleItem () {
      return get(this.column, 'styleItem', '')
    },
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    },
    rowId () {
      const { _id, id } = this.row
      return _id || id
    },
    typeInput () {
      const { typeInput } = this.column
      return typeInput || 'text'
    },
    value: {
      get () {
        const { prop } = this.column
        return get(this.row, prop, '')
      },
      set (data) {
        set(this.row, this.column.prop, data)
      }
    }
  },
  beforeMount () {
    this.defaultValue = this.value === 0 ? '' : this.value
  },
  methods: {
    minMaxInput (newVal) {
      const { min = 0, max = 100 } = this.column
      if (Number(newVal) > max) {
        this.defaultValue = max
      } else if (Number(newVal) < min) {
        this.defaultValue = min
      }
    },
    onUnSave () {
      this.updateRow('')
      this.defaultValue = ''
      this.isEdit = false
    },
    onSave () {
      this.value = this.defaultValue
      this.updateRow(this.defaultValue)
      this.isEdit = false
    },
    updateRow (value) {
      const currentElem = {row: this.row, column: this.column, value, isUpdate: true}
      this.$emit('updateProject', currentElem)
    },
    onEdit () {
      this.isEdit = true
    }
  },
  watch: {
    defaultValue (newVal) {
      if (newVal && newVal.length > 5) {
        this.defaultValue = newVal.slice(0, 5)
        return
      }
      this.minMaxInput(newVal)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../sass/variables';

.bbp-string-cell-edit {
  display: flex;
  align-items: center;
  position: relative;

  &__input {
    width: 100%;
    border-radius: 5px;
    border: 1px solid $color-mercury;
    padding: 6px 6px;
    margin: 0 8px 0 0;

    &_error {
      border: 1px solid $color-pomegranate;
    }
  }

  &__content {
    margin: 0 16px 0 0;
  }

  &__icon {
    position: relative;
    width: 21px;
    min-width: 21px;
    height: 21px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    background: $color-wild-sand;
    color: $color-accent;
    cursor: pointer;
    transition: opacity .2s ease-in;

    &:hover {
      opacity: 0.8;
    }

    &_unsave {
      background-color: $color-white;
      margin: 0 4px 0 0;
    }

    &_save {
      background-color: $color-white;
    }
  }

}
</style>

<style  lang="scss">

.placeholder-column_show {
  .bbp-string-cell-edit {

    &__icon {
      display: none;
    }

    &__content {
      margin: 0 !important;
    }
  }
}

.bbp-string-cell-edit__icon_popup {
  position: absolute !important;
  top: 5px;
  right:0;
}

.bbp-string-cell-edit {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPStringCellEdit/BBPStringCellEdit.vue